<template>
  <div class="bg-white rounded-[24px] border border-[#1c4848]/5 shadow-sm overflow-hidden">
    <div class="aspect-video bg-[#1c4848]/10 animate-pulse" />
    <div class="p-4 flex flex-col gap-2">
      <div class="h-5 w-2/3 rounded bg-[#1c4848]/15 animate-pulse" />
      <div class="h-4 w-1/2 rounded bg-[#1c4848]/10 animate-pulse" />
    </div>
  </div>
</template>

<script setup>
</script>
